<template>
  <div v-loading="isLoading">
    <el-table
      :data="clients"
      stripe
    >
      <el-table-column
        label="Description"
        prop="description"
        width="320px"
        sortable
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue ? cellValue : '-'"
      />

      <el-table-column
        label="Key"
        prop="key"
        width="320px"
        sortable
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue ? cellValue : '-'"
      />

      <el-table-column
        label="Role"
        prop="role"
        width="320px"
        sortable
        show-overflow-tooltip
        :formatter="(row, col, cellValue) => cellValue ? cellValue.name : '-'"
      />

      <el-table-column
        label="Actions"
        align="right"
        min-width="270px"
      >
        <!-- <template slot-scope="scope">
          <el-button
            size="mini"
            @click.native="editClient(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click.native="deleteClient(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template> -->
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <!-- Edit Form -->
    <ClientEditForm
      v-if="isShowEditForm"
      ref="editForm"
      :account-id="accountId"
      :client="client"
      :is-show.sync="isShowEditForm"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import ClientEditForm from '@/components/Application/Manage/Account/ClientEditForm'
export default {
  components: {
    ClientEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    teamId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      client: null,
      clients: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: false,
      isShowEditForm: false
    }
  },
  created () {
    this.loadTable()
  },
  mounted () {
    this.actions = [
      {
        name: 'Create',
        icon: ['fal', 'plus'],
        event: () => {
          this.client = new this.$sdk.client()
          this.isShowEditForm = true
        }
      },
      {
        name: 'Refresh',
        icon: ['fal', 'sync'],
        event: () => this.loadTable()
      }
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.client.list(builder => {
        builder.include = ['role']
        builder.filters = { team: [this.teamId] }
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'created_at:desc'
      })
        .then(res => {
          this.clients = res
          this.total = res.total
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editClient (index, row) {
      this.client = row.clone()
      this.isShowEditForm = true
    },
    deleteClient (index, row) {
      this.$confirm('Are you sure to delete this?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'pivot' }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
